import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import language from 'utils/vast-languagepack'
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
  withStyles,
} from '@material-ui/core'
import { handleSubjectChange } from 'actions/template'
import styles from './styles'
import textObjFn from 'utils/textObjFn'
const Handlebars = require('handlebars')

export default connect(
  state => {
    const task = state.tasks.tasksByID[state.tasks.addOrEdit.taskID]
    const stats = task?.sms_stats || task?.email_stats
    const campaignStatus =
      state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
    const automationTypeSelected = state.tasks.addOrEdit.automationTypeSelected
    const disabled = Boolean(
      (stats && automationTypeSelected !== 'stage') ||
        campaignStatus === 'L' ||
        campaignStatus === 'C',
    )
    const mergeFieldsPreviewSelectValue =
      state.tasks.addOrEdit.mergeFieldsPreviewSelect?.value
    const contact =
      mergeFieldsPreviewSelectValue === 'sample'
        ? {
            id: 'sample',
            first_name: 'Jane',
            middle_name: 'Emily',
            last_name: 'Doe',
            email: [
              {
                id: 'sample-email',
                address: 'jane.doe@example.com',
                opt_in: true,
                email_type: 'W',
              },
            ],
            phones: [
              {
                id: 'sample-phone',
                number: '+19999999999',
                opt_in: true,
                phone_type: 'M',
              },
            ],
            location: 'Huntingdon Valley, PA',
            notes: 'Such a nice person!',
            vastuser: Object.keys(state.data?.['account/user'] || {})?.[0],
          }
        : state.contacts.contactsWithEmailsByID?.[mergeFieldsPreviewSelectValue]

    return {
      value: state.email.subject.value,
      disabled,
      mergeFieldsPreviewSelectValue,
      contact,
      vastuser: state.data?.['account/user']?.[contact?.vastuser],
      preferences: state.data?.['account/preference']?.preferences,
      account: state.data?.account,
      assignedNumber: Object.values(state.data?.phonenumbers || {})?.find(
        numberObj => numberObj?.vast_user_name === contact?.vastuser,
      )?.phone_number,
      ...state.email.defaultValues,
    }
  },
  dispatch => bindActionCreators({ handleSubjectChange }, dispatch),
)(
  withStyles(styles)(
    class Subject extends Component {
      state = { focused: false }

      componentDidMount() {
        this.forceUpdate()
      }

      render() {
        const textObj = textObjFn(this.props)

        let compiledText = ''
        let text = ''

        try {
          compiledText = Handlebars.compile(this.props.value || '')
          text = compiledText(textObj)
        } catch (error) {
          console.log(error)
        }

        return (
          <FormControl
            disabled={this.props.disabled}
            fullWidth
            variant="outlined"
          >
            <InputLabel
              ref={ref => {
                this.labelRef = ReactDOM.findDOMNode(ref)
              }}
              htmlFor={`formTextField${'Description'}`}
              shrink
              style={{ transform: 'translate(44px, -6px) scale(0.75)' }}
            >
              {`${language.task.add.labels.subject} (required)`}
            </InputLabel>
            <OutlinedInput
              onBlur={() => this.setState({ focused: false })}
              onFocus={() => this.setState({ focused: true })}
              labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
              value={
                this.state.focused || !this.props.mergeFieldsPreviewSelectValue
                  ? this.props.value
                  : text
              }
              onChange={e => this.props.handleSubjectChange(e.target.value)}
              notched
              classes={{
                notchedOutline: this.props.warning
                  ? this.props.classes.notchedOutlineWarning
                  : this.props.classes.notchedOutline,
              }}
            />
            <FormHelperText>{this.props.helperText}</FormHelperText>
          </FormControl>
        )
      }
    },
  ),
)
